<div class="card shadow-sm rounded-3">
  <div class="card-body py-2">
    <div class="d-flex flex-wrap justify-content-between align-items-center">
      <h4 class="fw-bold text-dark m-0">
        <i class="las la-user me-2"></i> {{ "PROPERTY.OBJECT_DATA" | translate }}
      </h4>
      <button (click)="addPerson()" class="btn btn-primary btn-sm py-2 mt-2 mt-md-0">
        <i class="las la-plus me-1"></i> {{ "APARTMENT.ADD_PERSON" | translate }}
      </button>
    </div>

    <p class="text-muted mb-2 mt-2">{{ "APARTMENT.OBJECT_RESPONSIBLE" | translate }}</p>

    <div class="row g-2 align-items-center mb-3">
      <div class="col-12 col-md-6 col-lg-4">
        <div class="d-flex gap-2 align-items-center">
          <div class="w-100">
            <autocomplete
              (onSelect)="selectPerson($event)"
              [clearable]="false"
              [formControl]="form.controls.selectedPerson"
              [url]="usersService.getAll.bind(usersService)"
              label="MENU.UTILITY_TYPES">
              <ng-template #label let-item="item">
                {{ item | fullName }}
              </ng-template>
            </autocomplete>
          </div>
          <button
            (click)="updateResponsible()"
            [disabled]="!selectedPerson"
            class="btn btn-primary d-flex ms-1">
            <i class="las la-save me-1"></i>
            {{ 'SAVE' | translate }}
          </button>
          <div *ngIf="selectedPerson" class="">
            <div (click)="delete()" class="px-2 py-0 border border-secondary rounded-2 cursor-pointer">
              <i class="ri-delete-bin-5-line text-secondary" style="font-size: 24px"></i>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row g-3">
      <div class="col-12 col-md-6">
        <div class="p-2 border rounded">
          <ul class="list-unstyled mb-0">
            <li>
              <p class="d-flex"><span class="w-50 fw-bold">{{ "APARTMENT.NAME" | translate }}:</span> <span
                class="w-50">{{ getName(selectedPerson) }}</span></p>
            </li>
            <li>
              <p class="d-flex"><span class="w-50 fw-bold">{{ "APARTMENT.EMAIL" | translate }}:</span> <span
                class="w-50">{{ selectedPerson?.email || '-' }}</span></p>
            </li>
            <li>
              <p class="d-flex"><span class="w-50 fw-bold">{{ "APARTMENT.TELEPHONE" | translate }}:</span> <span
                class="w-50">{{ selectedPerson?.phoneNumber || '-' }}</span></p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
